import styles from './index.module.css'
import React from 'react'
import useI18n from '../../../lib/hooks/useI18n'
import { Tree } from '../../../types'
import WithHeader from '../../HOC/WithHeader'
import TileGroup from '../TileGroup'

interface Props {
  tree?: Tree
}

const Home = ({ tree }: Props) => {
  const { i18n } = useI18n()

  return (
    <div>
      <div className={styles['welcome-container']}>
        <p className={styles['big-blue-text']}>{i18n.welcome}</p>
        <p className={styles['big-blue-text']}>{i18n.access}</p>
      </div>
      <TileGroup tree={tree} />
    </div>
  )
}

export default WithHeader(Home)
